import { ValidatorKeyEnum } from '@/enums/ValidatorKeyEnum.enum';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
  standalone: true,
  imports: [TranslateModule]
})
export class ErrorMessageComponent implements OnInit, OnChanges {
  readonly UNKNOWN_ERROR = 'ErrorMessage.unkownMessage';

  @Input() errors: ValidationErrors = null;
  @Input() patternErrorLabel: string = null;

  message: string | null = this.UNKNOWN_ERROR;
  errorList: string[] = [];
  param = { key: '' };

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['errors']) {
      this.showMessage();
    }
  }

  showMessage() {
    this.setErrorList();
    this.setMessage();
  }

  setErrorList() {
    this.errorList = [];
    if (this.errors) {
      Object.keys(this.errors).forEach((e) => {
        this.errorList.push(e);
      });
    }
  }

  setMessage() {
    let m = this.UNKNOWN_ERROR;
    // show only first error (métier)
    if (this.errorList.length > 0) {
      const key = this.errorList[0];
      m = this.generateMessage(key as ValidatorKeyEnum);
    }
    this.message = m;
  }

  /**
   *
   * @param key
   * @returns translate key
   */
  generateMessage(key: ValidatorKeyEnum): string {
    this.param.key = '';
    switch (key) {
      case ValidatorKeyEnum.SIRET:
        return 'error.siret';
      case ValidatorKeyEnum.PHONE_NUMBER:
        return 'error.phoneNumber';
      case ValidatorKeyEnum.POSTAL_CODE:
        return 'error.postalCode';
      case ValidatorKeyEnum.REQUIRED:
        return 'error.required';
      case ValidatorKeyEnum.EMAIL:
        return 'error.email';
      case ValidatorKeyEnum.EMAIL_NOT_FOUND:
        return 'error.emailNotFound';
      case ValidatorKeyEnum.BAD_USER_ROLE:
        return 'error.badUserRole';
      case ValidatorKeyEnum.BAD_USER_NAME:
        return 'error.badUserName';
      case ValidatorKeyEnum.INVALID_DATE_AFTER:
        this.param['dateAfter'] = this.errors[ValidatorKeyEnum.INVALID_DATE_AFTER];
        return 'error.dateAfter';
      case ValidatorKeyEnum.MAX_LENGTH:
        const actualLength = this.errors['maxlength'].actualLength;
        const requiredLength = this.errors['maxlength'].requiredLength;
        return this.getMaxLengthMessage(actualLength, requiredLength);
      case ValidatorKeyEnum.MIN:
        const actualMin = this.errors['min'].actual;
        const requiredMin = this.errors['min'].min;
        return this.getMinMessage(actualMin, requiredMin);
      case ValidatorKeyEnum.INTEGER:
        return 'error.integer';
      case ValidatorKeyEnum.URL:
        return 'error.url';
      case ValidatorKeyEnum.PATTERN:
        return this.patternErrorLabel ? this.patternErrorLabel : 'error.pattern';
      default:
        return this.getUnknownMessage(key);
    }
  }

  getUnknownMessage(key: string): string {
    this.param.key = key;
    return this.UNKNOWN_ERROR;
  }

  getMaxLengthMessage(actualLength: number, requiredLength: number) {
    this.param['actualLength'] = actualLength;
    this.param['requiredLength'] = requiredLength;
    return 'error.maxlength';
  }

  getMinMessage(actual: number, required: number) {
    this.param['actualMin'] = actual;
    this.param['requiredMin'] = required;
    return 'error.min';
  }
}
